/* eslint-disable jsx-a11y/anchor-is-valid */
import { t } from "i18next";
import "./../stylesheets/components/IPhoneSearchPreview.scss";
import { CategoryState, selectCategoryState } from "../store/features/categorySlice";
import { useSelector } from "react-redux";
import { EstimateModel, selectEstimate } from "../store/features/estimateSlice";

export default function IPhoneSearchPreview() {
  const categoryState : CategoryState = useSelector(selectCategoryState);
  const estimateState: EstimateModel = useSelector(selectEstimate);

  return (
    <>
      <div className="preview-iphone">
        {/* <div className="header">{{Messages.advancedSettings.mobileHeader}}</div> */}
        <div className="iphone">
          <div className="iphone-screen">
            <div className="iphone-google-search-header">
              <div>
                <div className="_RAf" id="qslc">
                  <a className="_Ejh">
                    <div className="_Djh" aria-label="Google"></div>
                  </a>
                </div>
              </div>
              <div className="_cy" id="sfcnt">
                <div
                  className="sbox"
                  data-jibp="h"
                  data-jiis="uc"
                  id="gws-quantum-experimental_page_header__sbox"
                >
                  <form style={{ background: "none" }} id="tsf2" name="gs">
                    <div id="tophf" data-jibp="">
                      <input
                        value="y3ZSWePvAaj36AT4r4yQCA"
                        name="ei"
                        type="hidden"
                      />
                    </div>
                    <div className="msb" id="tmsb">
                      <div className="msfo">
                        <div
                          className="msfi"
                          id="tsfi"
                          style={{ zoom: 1, position: "relative" }}
                        >
                          <div id="gs_id0">
                            <div className="sb_ifc" id="sb_ifc0">
                              <div className="sb_chc" id="sb_chc0"></div>
                              <input
                                className="lst lst-tbb gsfi"
                                id="lst-ib"
                                name="q"
                                title={t("preview.search.search")}
                                type="search"
                                value=""
                                readOnly
                                style={{ outline: "none" }}
                              />
                              <div className="gsst_b" id="gs_st0" dir="ltr">
                                <a className="gsst_a">
                                  <span
                                    className="sbcb_a"
                                    id="sb_cb0"
                                    aria-label={t("preview.search.clearSearch")}
                                  >
                                    x
                                  </span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <button
                        className="lsbb"
                        id="tsbb"
                        name="btnG"
                        type="submit"
                      >
                        <div className="sbico">
                          <span className="_wtf _Qtf">
                            <svg
                              focusable="false"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                            >
                              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"></path>
                            </svg>
                          </span>
                        </div>
                      </button>
                    </div>
                    <div id="sbfbl" style={{ display: "none" }}>
                      <div
                        style={{ display: "none" }}
                        className="r-igcwimhxMILE"
                      ></div>
                      <div id="duf3-46" className="y yp"></div>
                      <a className="duf3 _sWr" id="sbfblt">
                        {t("preview.search.reportPredictions")}
                      </a>
                    </div>
                    <div
                      className="gstl_0 sbdd_a"
                      style={{
                        display: "none",
                        minWidth: "266px",
                        position: "relative",
                      }}
                    >
                      <div className="fl"></div>
                      <div>
                        <div className="sbdd_b"></div>
                        <div></div>
                      </div>
                    </div>
                    <input type="hidden" name="oq" />
                    <input type="hidden" name="gs_l" />
                  </form>
                </div>
                <div id="msc">
                  <div id="msd">
                    <div className="_zKj"></div>
                    <div id="hdtb-sc">
                      <div id="hdtb-msb">
                        <div className="hdtb-mitem hdtb-msel hdtb-imb">
                          {t("preview.search.allTabLabel").toUpperCase()}
                        </div>
                        <div className="hdtb-mitem hdtb-imb">
                          <a className="q qs">
                            {t("preview.search.videosTabLabel").toUpperCase()}
                          </a>
                        </div>
                        <div className="hdtb-mitem hdtb-imb">
                          <a className="q qs">
                            {t("preview.search.imagesTabLabel").toUpperCase()}
                          </a>
                        </div>
                        <div className="hdtb-mitem hdtb-imb">
                          <a className="q qs">
                            {t("preview.search.newsTabLabel").toUpperCase()}
                          </a>
                        </div>
                        <div className="hdtb-mitem hdtb-imb">
                          <a className="q qs">
                            {t("preview.search.mapsTabLabel").toUpperCase()}
                          </a>
                        </div>
                        <div className="hdtb-mitem hdtb-imb">
                          <a className="q qs">
                            {t("preview.search.booksTabLabel").toUpperCase()}
                          </a>
                        </div>
                        <a className="hdtb-tl" id="hdtb-tls">
                          {t("preview.search.searchTools")}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="ads-ad mnr-c">
              <div className="ad_cclk">
                <a id="vs0p1c0" className="r-i9E444e1_G94">
                  <div className="_uWj">
                    <h3 className="_Tkg">
                      {categoryState.categoryAdCopy?.headline || t("preview.search.headline")}&lrm;
                    </h3>
                    <div className="ads-visurl">
                      <span className="_mB">{t("preview.search.ad")}</span>
                      <cite>{t("preview.search.path")}</cite>&lrm;
                    </div>
                  </div>
                </a>
              </div>
              <div className="_RYh _Bsm"></div>
              <div className="ads-ad-as">
                <div className="_mDc _icr ads-creative">
                  {categoryState.categoryAdCopy?.description || t("preview.search.description")}
                </div>

                <div className="_pjm ads-section">
                  <a className="ellip _qjm" style={{ display: "block" }}>
                    <span className="_cBb _Sxg _bjm"></span>
                    <div className="_k3o ellip">
                      {estimateState.phoneNumber.number || t("preview.search.phoneNumber")}
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
